import {IconProps} from "../../types/IconProps";

export const WritingIcon = ({ width = 800, color = '#000'}: IconProps) => {
    return (
        <svg fill={color} height={`${width}px`} width={`${width}px`} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491.52 491.52">
            <g>
                <g>
                    <g>
                        <polygon points="204.8,12.001 204.8,122.88 315.679,122.88"/>
                        <path d="M163.84,143.36V0H20.48C9.175,0,0,9.175,0,20.48v450.56c0,11.305,9.175,20.48,20.48,20.48H307.2
                            c11.305,0,20.48-9.175,20.48-20.48v-307.2H184.32C173.015,163.84,163.84,154.665,163.84,143.36z M225.28,409.6H81.92
                            c-11.305,0-20.48-9.175-20.48-20.48c0-11.305,9.175-20.48,20.48-20.48h143.36c11.305,0,20.48,9.175,20.48,20.48
                            C245.76,400.425,236.585,409.6,225.28,409.6z M225.28,327.68H81.92c-11.305,0-20.48-9.175-20.48-20.48
                            c0-11.305,9.175-20.48,20.48-20.48h143.36c11.305,0,20.48,9.175,20.48,20.48C245.76,318.505,236.585,327.68,225.28,327.68z
                             M245.76,225.28c0,11.305-9.175,20.48-20.48,20.48H81.92c-11.305,0-20.48-9.175-20.48-20.48c0-11.305,9.175-20.48,20.48-20.48
                            h143.36C236.585,204.8,245.76,213.975,245.76,225.28z"/>
                        <path d="M368.64,409.6c0,4.035,1.208,8.008,3.441,11.366l40.96,61.44c3.809,5.693,10.199,9.114,17.039,9.114
                            c6.84,0,13.23-3.42,17.039-9.114l40.96-61.44c2.232-3.359,3.441-7.332,3.441-11.366V143.36H368.64V409.6z"/>
                        <path d="M430.08,0c-33.874,0-61.44,27.566-61.44,61.44v40.96h122.88V61.44C491.52,27.566,463.954,0,430.08,0z"/>
                    </g>
                </g>
            </g>
        </svg>
    )
}